import React from "react";
import { TreeSelect } from "antd";

const AntDesignTree = ({
  treeData,
  value,
  onChange,
  onSelect,
  placeholder = "Select",
  treeCheckable = false, 
  multiple = true,
  showSearch = true,
  showCheckedStrategy = TreeSelect.SHOW_PARENT,
  getPopupContainer = null,
  tagRender: customTagRender,
}) => {

  // Recursive search to return the full path
  const findNodePath = (nodes, val, path = []) => {
    for (let node of nodes) {
      if (node.key === val) {
        return [...path, node];
      }
      if (node.children) {
        const found = findNodePath(node.children, val, [...path, node]);
        if (found) return found;
      }
    }
    return null;
  };

  const defaultTagRender = (props) => {
    const { value: val, closable, onClose } = props;

    const path = findNodePath(treeData, val) || [];
    const displayText = path.map((n) => n.title).join(" → "); // 👈 dynamic path

        return (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              background: "#f0f0f0",
              borderRadius: "4px",
              padding: "0 8px",
              marginRight: "4px",
            }}
          >
            {displayText}
            {closable && (
              <span
                onClick={onClose}
                style={{ marginLeft: 4, cursor: "pointer", fontWeight: "bold" }}
              >
                ×
              </span>
            )}
          </span>
        );
  };

  return (
    <TreeSelect
      treeData={treeData}
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      treeCheckable={treeCheckable}
      multiple={multiple}
      showCheckedStrategy={showCheckedStrategy}
      placeholder={placeholder}
      showSearch={showSearch}
      treeNodeFilterProp="title"
      style={{ width: "100%" }}
      getPopupContainer={getPopupContainer}
      tagRender={customTagRender || defaultTagRender}
    />
  );
};

export default AntDesignTree;
